import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from "src/app/core";
import { EventVendorsService } from "../../event-vendors";
import { EventContextService } from "../../events";
import { VisionboardAttributesService, VisionboardCategoriesService, VisionboardVersionsService } from "../../visionboard";
import { VenueAdminService } from "./venue-admin.service";

@Injectable()
export class VenueAdminInventoryAttributesService extends VisionboardAttributesService {
  constructor(
    visionboardCategoriesService: VisionboardCategoriesService,
    visionboardVersionsService: VisionboardVersionsService,
    protected appConfigService: AppConfigService,
    http: HttpClient,
    eventVendorsService: EventVendorsService,
    eventContextService: EventContextService,
    private _venueAdminService: VenueAdminService,
  ) {
    super(visionboardCategoriesService, visionboardVersionsService, appConfigService, http, eventVendorsService, eventContextService);
  }

  protected override getAttributesUrl(subCategoryId: number): string {
    return this.appConfigService.getVenueAdminInventoryAttributesUrl(this._venueAdminService.activeVenue.id, subCategoryId);
  }
}
